import { cn } from '@/lib/utils';

const FOCUS_RING =
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-zinc-900 focus-visible:ring-offset-2 dark:focus-visible:ring-zinc-100 dark:focus-visible:ring-offset-zinc-950';

export function optionChipClass(
  active: boolean,
  { invalid = false, disabled = false } = {},
): string {
  return cn(
    'inline-flex items-center rounded-md border px-3 py-1.5 text-sm font-medium transition-colors',
    FOCUS_RING,
    active
      ? 'border-zinc-900 bg-zinc-900 text-white dark:border-zinc-100 dark:bg-zinc-100 dark:text-zinc-900'
      : 'border-zinc-200 bg-white text-zinc-700 hover:border-zinc-400 hover:bg-zinc-50 dark:border-zinc-800 dark:bg-dark-card dark:text-zinc-300 dark:hover:border-zinc-600 dark:hover:bg-zinc-900',
    invalid && !active && 'border-destructive',
    disabled && 'pointer-events-none opacity-60',
  );
}

export function optionCardClass(active: boolean): string {
  return cn(
    'rounded-md border p-3 text-left transition-colors',
    FOCUS_RING,
    active
      ? 'border-zinc-900 bg-zinc-50 ring-1 ring-zinc-900 dark:border-zinc-100 dark:bg-zinc-900 dark:ring-zinc-100'
      : 'border-zinc-200 hover:border-zinc-400 hover:bg-zinc-50 dark:border-zinc-800 dark:hover:border-zinc-600 dark:hover:bg-zinc-900',
  );
}
